import { z } from "zod";
import type { Operation } from "../types";

// Gateway-profile health chips (docs/models/PRD.md §8.5.2 / §14). Reads the
// ephemeral `provider-health.json` state; the checkup re-runs the doctor via the
// `excellent-mcp provider doctor` CLI seam. No secret material crosses this wire.

export const healthState = z.enum(["unverified", "healthy", "degraded", "quarantined"]);
export type HealthState = z.infer<typeof healthState>;

export const profileHealth = z.object({
  id: z.string(),
  state: healthState,
  reasons: z.array(z.string()),
  keyPresent: z.boolean(),
  baseUrl: z.string().nullable(),
  refused: z.boolean(),
  lastProbeAt: z.string().nullable(),
});
export type ProfileHealth = z.infer<typeof profileHealth>;

const healthResponse = z.object({
  cliVersion: z.string().nullable(),
  profiles: z.array(profileHealth),
  /** True when the health/profile data came from the live `excellent-mcp` CLI. */
  cliAvailable: z.boolean(),
});
export type ModelsHealthResponse = z.infer<typeof healthResponse>;

const get: Operation<void, void, void, ModelsHealthResponse> = {
  method: "GET",
  path: () => "/api/models/health",
  response: healthResponse,
};

const checkupBody = z.object({
  provider: z.string().optional(),
  live: z.boolean().optional(),
});
const checkupResponse = healthResponse.extend({
  ok: z.boolean(),
  ran: z.boolean(),
  message: z.string().optional(),
});

const checkup: Operation<void, void, z.infer<typeof checkupBody>, z.infer<typeof checkupResponse>> = {
  method: "POST",
  path: () => "/api/models/health/checkup",
  body: checkupBody,
  response: checkupResponse,
};

export const modelsHealth = { get, checkup };
